import { useState, useEffect } from "react";
import styles from "./Toggle.module.css";
import { useSearchParams } from 'react-router-dom';

const Toggle = ({ variant = "switch", label = "Free only", onBeforeChange }) => {
  const [isOn, setIsOn] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsKey = searchParams.toString();

  // Initialize toggle state based on searchParams on initial render
  useEffect(() => {
    const currentSearchParams = new URLSearchParams(searchParamsKey);
    const nextIsOn = currentSearchParams.get("access_type") === "free";
    setIsOn((prev) => (prev === nextIsOn ? prev : nextIsOn));
  }, [searchParamsKey]);

  const updateToggleState = (nextIsOn) => {
    if (nextIsOn === isOn) {
      return;
    }

    onBeforeChange?.();
    setIsOn(nextIsOn);
    const updatedSearchParams = new URLSearchParams(searchParams);

    if (nextIsOn) {
      updatedSearchParams.set("access_type", "free");
    } else {
      updatedSearchParams.delete("access_type");
    }
    updatedSearchParams.delete("page");
    updatedSearchParams.delete("page_size");

    setSearchParams(updatedSearchParams);
  };

  if (variant === "segmented") {
    return (
      <div className={styles.segmentedToggle} role="group" aria-label={label}>
        <button
          type="button"
          className={`${styles.segmentButton} ${!isOn ? styles.segmentButtonActive : ""}`}
          onClick={() => updateToggleState(false)}
          aria-pressed={!isOn}
        >
          All
        </button>
        <button
          type="button"
          className={`${styles.segmentButton} ${isOn ? styles.segmentButtonActive : ""}`}
          onClick={() => updateToggleState(true)}
          aria-pressed={isOn}
        >
          Free
        </button>
      </div>
    );
  }

  return (
    <div>
      <div
        className={`${styles.toggleSwitch} ${isOn ? styles.on : ""}`}
        onClick={() => updateToggleState(!isOn)}
      >
        <div className={styles.toggleButton}></div>
      </div>
    </div>
  );
};

export default Toggle;
